import { useQuery } from '@tanstack/react-query';

import { stockApi } from '@/api/stock';
import { useAuth } from '@/hooks/useAuth';
import { queryKeys } from '@/lib/query-client';

export function useSellerApprovalCounts(locationId?: string, enabled = true) {
  const { user } = useAuth({ skipInitialCheck: true });
  return useQuery({
    queryKey: [...queryKeys.stock.sellerWorkspace.all, 'approval-counts', locationId ?? 'all'],
    queryFn: () => stockApi.sellerWorkspace.approvalCounts(locationId),
    enabled: enabled && user?.role === 'admin',
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
    staleTime: 0,
  });
}
